import { IoMdAdd, IoMdPlay } from "react-icons/io";
import { MdBallot, MdClose, MdEdit, MdSave } from "react-icons/md";
import { Button, Input, Spinner } from "reactstrap";
import "../../../assets/css/top_menu_bar.css";
import { useState } from "react";
import NovaFuncao from "../../../components/Workflow/NovaFuncao";

function TopMenuBar({
  title = "title",
  readonly = false,
  closed = false,
  closeButton = false,
  onCloseButton = false,
  onChange,
  onChageFunction,
  onSave,
  onRun,
  load,
}) {
  const [edit, setEdit] = useState(false);
  const [modalAdd, setModalAdd] = useState(false);
  const _onChageFunction = (e) => {
    onChageFunction(e);
    setModalAdd(false);
  };

  return (
    <>
      <div className="active-code">
        {!closed && (
          <div
            className="function-name-container"
            style={{ display: "flex", gap: 20 }}
          >
            {!edit ? (
              <div className="function-name-wrapper">
                {!readonly && (
                  <div>
                    <span
                      className="edit-name-wrapper"
                      onClick={() => setEdit(true)}
                    >
                      <MdEdit color="var(--primary)" />
                    </span>
                  </div>
                )}
                <div>
                  <span className="function-name" onClick={() => setEdit(true)}>
                    {title}
                  </span>
                </div>
              </div>
            ) : (
              <div className="rename-active">
                <Input value={title} onChange={onChange} />
                <Button
                  color="primary"
                  className="button-mid-height"
                  onClick={() => setEdit(false)}
                >
                  <MdSave size={10} />
                </Button>
              </div>
            )}
          </div>
        )}
        <div className="active-actions">
          {!readonly && (
            <Button
              className="button-mid-height"
              color="primary"
              style={{ marginRight: 20 }}
              onClick={() => setModalAdd(true)}
              disabled={load}
              size="sm"
            >
              <IoMdAdd /> Adicionar Função
            </Button>
          )}
          {!readonly && (
            <Button
              className="button-mid-height"
              color="success"
              onClick={() => onRun()}
              disabled={load}
              size="sm"
            >
              {!load ? <IoMdPlay /> : <Spinner size="sm" />} Rodar
            </Button>
          )}
          {!readonly && (
            <Button
              color="primary"
              className="button-mid-height"
              onClick={onSave}
              disabled={load}
              size="sm"
            >
              <MdSave /> Salvar
            </Button>
          )}

          {closeButton && (
            <div
              className="close-icon"
              onClick={() => onCloseButton && onCloseButton()}
            >
              <MdClose />
            </div>
          )}
        </div>
      </div>
      <NovaFuncao
        open={modalAdd}
        toggle={() => setModalAdd(!modalAdd)}
        onChageFunction={_onChageFunction}
      />
    </>
  );
}

export default TopMenuBar;
